import BrandLogo from "./BrandLogo";

const LINKS = [
  { href: "/terms", label: "Terms", testid: "footer-terms" },
  { href: "/privacy", label: "Privacy", testid: "footer-privacy" },
  { href: "/commercial-terms", label: "Commercial Terms", testid: "footer-commercial" },
  { href: "mailto:hello@pitchdhq.com", label: "Contact", testid: "footer-contact" },
];

/**
 * Shared footer used across the public website, auth pages, and the logged-in
 * app. Plain <a> tags (not react-router <Link>) so it can be safely mounted
 * inside contexts that live outside the Router (e.g. AuthProvider).
 */
export default function SiteFooter({ variant = "default" }) {
  const compact = variant === "compact";
  return (
    <footer
      className={`border-t border-line ${compact ? "py-6" : "py-8"} mt-12`}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-ink-dim">
        <div className="flex items-center gap-2 uppercase tracking-widest" data-testid="footer-brand">
          <BrandLogo variant="icon" size={14} showLink={false} className="opacity-80" alt="PITCHD" data-testid="footer-logo" />
          <span>© 2026 PITCHD. All rights reserved.</span>
          <span className="hidden md:inline text-ink-dim/70">·</span>
          <span className="hidden md:inline text-ink-dim/70 normal-case tracking-normal">pitchdhq.com</span>
        </div>
        <nav className="flex flex-wrap items-center gap-5 uppercase tracking-widest">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-volt" data-testid={l.testid}>
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
